export class Dados {
  dataInicial: string;
  dataFinal: string;
}



// WEBPACK FOOTER //
// ./src/app/relatorios/dados.ts